<template lang="pug">
.accounts_page
  .columns(style='margin-bottom: -2em;' v-if='$store.state.ui.online')
    .column
      .dropdown.is-hoverable
        .dropdown-trigger
          a.button.is-small.is-rounded
            span.icon.is-small: v-icon(name="angle-down")
            span {{ $t('Create') }}
        .dropdown-menu(role='menu')
          .dropdown-content
            a.dropdown-item(@click="$store.dispatch('newAccount')") {{ $t('Account') }}
            a.dropdown-item(@click="$store.dispatch('newAccountCategory')") {{ $t('Category') }}
            //- a.dropdown-item {{ $t('transfer') }} {{ $t('transfer_accounts') }}

    .column.has-text-right
      a.button.is-small.is-rounded(@click="$store.dispatch('newVirtual')")
        span.icon.is-small: v-icon(name='plus')
        span {{ $t('New Envelope') }}
  .has-text-centered: stats
  br
  .columns
    //- ACCOUNTS
    .column.is-6(style='border-right: 1px dotted #dbdbdb; position: relative;')
      //- .subtitle.is-6: accounts_stats
      account_edit
      account_category_edit

      div(v-for='category in account_categories')
        account_category(:category='category', :key='category.name')
        br

      div(v-if="$store.state.ui.online"): small
        router-link.button.is-light.is-small.is-rounded(:to="{ name: 'import_page' }")
          span.icon: v-icon(name='upload')
          span  {{ $t('Import from CSV') }}

    //- //////////////////////
    //- VIRTUALS
    //- //////////////////////
    .column.is-6
      //- .subtitle.is-6: virtual_stats
      virtual_edit

      template(v-for='category in $store.getters.virtual_categories')
        virtual_category(v-if='category.children().length > 0', :category='category')
        br
</template>

<script>
import Account from 'models/account.coffee'
import Virtual from 'models/virtual.coffee'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/upload'
import 'vue-awesome/icons/angle-down'

Vue.use(require('element-ui/lib/col').default)

export default {
  name: 'accounts',
  metaInfo()  {
    return { title: this.$t('Accounts and Envelopes') }
  },
  components: {
    account_category:    require('components/inside/pages/accounts/category.vue').default,
    account_category_edit: require('components/inside/pages/accounts/account_category_edit.vue').default,
    stats:               require('components/inside/pages/accounts/stats.vue').default,
    account_edit:        require('components/inside/pages/accounts/edit.vue').default,
    virtual_category:    require('components/inside/pages/virtuals/category.vue').default,
    virtual_edit:        require('components/inside/pages/virtuals/edit.vue').default
  },
  computed: {
    account_categories() { return this.$store.getters.account_categories; }
  },
  mounted() {
    this.event = `keyup.${this.$options.name}`;
    return $(window).off(this.event).on(this.event, e => {
      if (e.keyCode === 27) {
        this.$store.commit('ACCOUNTS/EDIT', null)
        this.$store.commit('VIRTUALS/EDIT', null)
        this.$store.commit('ACCOUNT_CATEGORIES/EDIT', null)
      }
      return false;
    });
  },
  destroyed() { return $(window).off(this.event); }
};
</script>

<i18n>
ru:
  'Import from CSV': 'Импортировать из CSV'
</i18n>
